import { useGetSwiftlaneUserGroups } from '@/api/keyless/swiftlane/get-swiftlane-user-groups'

import { swiftlaneDefaultValues } from './swiftlane.schema'

export const useSwiftlaneConnection = (buildingId: number) => {
  // Note: reused as-is — same building-scoped `/swiftlane/user-group/{buildingId}` endpoint
  // the legacy card calls purely as an existence probe; the response body is discarded there
  // too, only success/failure is used to derive `isConfigured`.
  const { isSuccess, isLoading } = useGetSwiftlaneUserGroups({ buildingId })

  return { isConfigured: isSuccess, isLoading, values: swiftlaneDefaultValues }
}
